export const getFileIcon = (extension) => {
  const iconSize = "w-5 h-5";

  switch (extension?.toLowerCase()) {
    case "txt":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-purple-500 shadow-sm`}>
          <svg
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className="G98Kb"
            style={{ width: 16, height: 16 }}>
            <path d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zM5.333 12.444H3.556v-1.777h1.777v1.777zm0-3.555H3.556V7.11h1.777V8.89zm0-3.556H3.556V3.556h1.777v1.777zm7.111 7.111H6.222v-1.777h6.222v1.777zm0-3.555H6.222V7.11h6.222V8.89zm0-3.556H6.222V3.556h6.222v1.777z"></path>
          </svg>
        </div>
      );

    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
    case "ico":
    case "svg":
    case "avif":
    case "bmp":
    case "heif":
    case "heic":
    case "tiff":
    case "tif":
    case "raw":
    case "pgf":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-red-500 shadow-sm`}>
          <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="k2eJge"
            style={{ width: 16, height: 16 }}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 14.222V1.778C16 .796 15.204 0 14.222 0H1.778C.796 0 0 .796 0 1.778v12.444C0 15.204.796 16 1.778 16h12.444c.982 0 1.778-.796 1.778-1.778zM4.889 9.333l2.222 2.671L10.222 8l4 5.333H1.778l3.11-4z"></path>
          </svg>
        </div>
      );

    case "pdf":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-red-500 shadow-sm`}>
          <svg
            className="k2eJge"
            style={{ width: 16, height: 16 }}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="currentColor"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M1.778 0h12.444C15.2 0 16 .8 16 1.778v12.444C16 15.2 15.2 16 14.222 16H1.778C.8 16 0 15.2 0 14.222V1.778C0 .8.8 0 1.778 0zm2.666 7.556h-.888v-.89h.888v.89zm1.334 0c0 .737-.596 1.333-1.334 1.333h-.888v1.778H2.222V5.333h2.222c.738 0 1.334.596 1.334 1.334v.889zm6.666-.89h2.223V5.334H11.11v5.334h1.333V8.889h1.334V7.556h-1.334v-.89zm-2.222 2.667c0 .738-.595 1.334-1.333 1.334H6.667V5.333h2.222c.738 0 1.333.596 1.333 1.334v2.666zm-1.333 0H8V6.667h.889v2.666z"></path>
          </svg>
        </div>
      );

    case "xls":
    case "xlsx":
    case "csv":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-green-500 shadow-sm`}>
          <svg
            className="c7bJtd"
            style={{ width: 16, height: 16 }}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="currentColor"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.222 0H1.778C.8 0 .008.8.008 1.778L0 4.444v9.778C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm0 7.111h-7.11v7.111H5.332v-7.11H1.778V5.332h3.555V1.778h1.778v3.555h7.111v1.778z"></path>
          </svg>
        </div>
      );

    case "doc":
    case "docx":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-blue-500 shadow-sm`}>
          <svg
            className="auHQVc"
            style={{ width: 16, height: 16 }}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="currentColor"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm-1.769 5.333H3.556V3.556h8.897v1.777zm0 3.556H3.556V7.11h8.897V8.89zm-2.666 3.555H3.556v-1.777h6.23v1.777z"></path>
          </svg>
        </div>
      );

    case "ppt":
    case "pptx":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-orange-600 shadow-sm`}>
          <svg
            className="h-4 w-4 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12H11C12.1,12 13,12.9 13,14V15C13,16.1 12.1,17 11,17H9V18H8V12M9,13V16H11V15V14V13H9Z" />
          </svg>
        </div>
      );

    case "mp4":
    case "mov":
    case "avi":
    case "mkv":
    case "webm":
    case "wmv":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-purple-600 shadow-sm`}>
          <svg
            fill="currentColor"
            className="iEljJb"
            style={{ width: 16, height: 16 }}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M5.778 5.803v4.392L9.333 8 5.778 5.803z"></path>
            <path d="M14.222 0H1.778C.798 0 0 .798 0 1.778v12.444C0 15.202.798 16 1.778 16h12.444c.98 0 1.778-.798 1.778-1.778V1.778C16 .798 15.202 0 14.222 0ZM4 13.333V2.667L12.889 8 4 13.333Z"></path>
          </svg>
        </div>
      );

    case "mp3":
    case "wav":
    case "flac":
    case "aac":
    case "ogg":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-white text-blue-800 shadow-sm`}>
          <svg
            fill="currentColor"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className="k2eJge"
            style={{ width: 16, height: 16 }}>
            <path d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zM3.733 13.333a1.07 1.07 0 0 1-1.066-1.066V8A5.338 5.338 0 0 1 8 2.667 5.338 5.338 0 0 1 13.333 8v4.267a1.07 1.07 0 0 1-1.066 1.066h-2.49V9.778h1.779V8A3.555 3.555 0 0 0 8 4.444 3.555 3.555 0 0 0 4.444 8v1.778h1.778v3.555H3.733z"></path>
          </svg>
        </div>
      );

    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm text-amber-600 shadow-sm`}>
          <svg
            fill="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: 20, height: 20 }}>
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M10,11H11V12H10V11M11,12H12V13H11V12M10,13H11V14H10V13M11,14H12V15H11V14M10,15H11V16H10V15M11,16H12V17H11V16M12,17H13V18H12V17M13,16V18H15V16H13Z" />
          </svg>
        </div>
      );

    case "js":
    case "jsx":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-yellow-600 bg-yellow-500 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-black">JS</span>
        </div>
      );

    case "ts":
    case "tsx":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-blue-700 bg-blue-600 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-white">TS</span>
        </div>
      );

    case "css":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-blue-600 bg-blue-500 shadow-sm`}>
          <span className="text-[9px] font-bold leading-none text-white">CSS</span>
        </div>
      );

    case "html":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-orange-600 bg-orange-500 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-white">HTML</span>
        </div>
      );

    case "json":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-gray-700 shadow-sm`}>
          <svg
            className="h-4 w-4 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12V16H9V15H10V14H9V13H10V12H8M11,12V16H12V12H11M13,12V13H14V15H13V16H15V15H14V13H15V12H13Z" />
          </svg>
        </div>
      );

    case "py":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-blue-700 bg-blue-600 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-white">PY</span>
        </div>
      );

    case "java":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-red-800 bg-red-700 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-white">JAVA</span>
        </div>
      );

    case "php":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm border border-purple-800 bg-purple-700 shadow-sm`}>
          <span className="text-xs font-bold leading-none text-white">PHP</span>
        </div>
      );

    case "md":
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-gray-800 shadow-sm`}>
          <svg
            className="h-4 w-4 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12H10L11,14L12,12H14V18H13V14L11,16L9,14V18H8V12Z" />
          </svg>
        </div>
      );

    default:
      return (
        <div className={`${iconSize} flex items-center justify-center rounded-sm bg-gray-500 shadow-sm`}>
          <svg
            className="h-4 w-4 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
        </div>
      );
  }
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export function truncateFileName(name, ext, maxLength = 20) {
  const totalLength = name.length + ext.length + 1;
  if (totalLength <= maxLength) {
    return `${name}.${ext}`;
  }
  const keep = maxLength - (ext.length + 4);
  const truncated = name.slice(0, keep);

  return `${truncated}...${ext}`;
}

export const getBoxShadow = (level) => {
  switch (Number(level)) {
    case 1:
      return "0 1px 2px rgba(0,0,0,0.05)";
    case 2:
      return "0 2px 4px rgba(0,0,0,0.08)";
    case 3:
      return "0 4px 6px rgba(0,0,0,0.10)";
    case 4:
      return "0 6px 8px rgba(0,0,0,0.12)";
    case 5:
      return "0 8px 12px rgba(0,0,0,0.15)";
    default:
      return "none";
  }
};

export const borderMap = (level = 1, color = "#E5E7EB") => `${Number(level)}px solid ${color}`;

export const getFileIconHtml = (extension) => {
  const wrapperStyle = "width: 32px; height: 32px; display: inline-flex; align-items: center; justify-content: center; border-radius: 6px; box-shadow: 0 1px 2px rgba(0,0,0,0.05); border-width: 1px; border-style: solid;";
  const svgStyle = "width: 18px; height: 18px;";

  switch (extension?.toLowerCase()) {
    case "txt":
      return `
        <div style="${wrapperStyle} background-color: #f3e8ff; color: #a855f7; border-color: #e9d5ff;">
          <svg viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zM5.333 12.444H3.556v-1.777h1.777v1.777zm0-3.555H3.556V7.11h1.777V8.89zm0-3.556H3.556V3.556h1.777v1.777zm7.111 7.111H6.222v-1.777h6.222v1.777zm0-3.555H6.222V7.11h6.222V8.89zm0-3.556H6.222V3.556h6.222v1.777z"></path>
          </svg>
        </div>
      `;

    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "webp":
    case "ico":
    case "svg":
    case "avif":
    case "bmp":
    case "heif":
    case "heic":
    case "tiff":
    case "tif":
    case "raw":
    case "pgf":
      return `
        <div style="${wrapperStyle} background-color: #fce7f3; color: #db2777; border-color: #fbcfe8;">
          <svg fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M16 14.222V1.778C16 .796 15.204 0 14.222 0H1.778C.796 0 0 .796 0 1.778v12.444C0 15.204.796 16 1.778 16h12.444c.982 0 1.778-.796 1.778-1.778zM4.889 9.333l2.222 2.671L10.222 8l4 5.333H1.778l3.11-4z"></path>
          </svg>
        </div>
      `;

    case "pdf":
      return `
        <div style="${wrapperStyle} background-color: #fee2e2; color: #ef4444; border-color: #fecaca;">
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M1.778 0h12.444C15.2 0 16 .8 16 1.778v12.444C16 15.2 15.2 16 14.222 16H1.778C.8 16 0 15.2 0 14.222V1.778C0 .8.8 0 1.778 0zm2.666 7.556h-.888v-.89h.888v.89zm1.334 0c0 .737-.596 1.333-1.334 1.333h-.888v1.778H2.222V5.333h2.222c.738 0 1.334.596 1.334 1.334v.889zm6.666-.89h2.223V5.334H11.11v5.334h1.333V8.889h1.334V7.556h-1.334v-.89zm-2.222 2.667c0 .738-.595 1.334-1.333 1.334H6.667V5.333h2.222c.738 0 1.333.596 1.333 1.334v2.666zm-1.333 0H8V6.667h.889v2.666z"></path>
          </svg>
        </div>
      `;

    case "xls":
    case "xlsx":
    case "csv":
      return `
        <div style="${wrapperStyle} background-color: #d1fae5; color: #10b981; border-color: #a7f3d0;">
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M14.222 0H1.778C.8 0 .008.8.008 1.778L0 4.444v9.778C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm0 7.111h-7.11v7.111H5.332v-7.11H1.778V5.332h3.555V1.778h1.778v3.555h7.111v1.778z"></path>
          </svg>
        </div>
      `;

    case "doc":
    case "docx":
      return `
        <div style="${wrapperStyle} background-color: #dbeafe; color: #2563eb; border-color: #bfdbfe;">
          <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zm-1.769 5.333H3.556V3.556h8.897v1.777zm0 3.556H3.556V7.11h8.897V8.89zm-2.666 3.555H3.556v-1.777h6.23v1.777z"></path>
          </svg>
        </div>
      `;

    case "ppt":
    case "pptx":
      return `
        <div style="${wrapperStyle} background-color: #ffedd5; color: #ea580c; border-color: #fed7aa;">
          <svg fill="currentColor" viewBox="0 0 24 24" style="${svgStyle}">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12H11C12.1,12 13,12.9 13,14V15C13,16.1 12.1,17 11,17H9V18H8V12M9,13V16H11V15V14V13H9Z" />
          </svg>
        </div>
      `;

    case "mp4":
    case "mov":
    case "avi":
    case "mkv":
    case "webm":
    case "wmv":
      return `
        <div style="${wrapperStyle} background-color: #fae8ff; color: #c084fc; border-color: #f5d0fe;">
          <svg fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path d="M5.778 5.803v4.392L9.333 8 5.778 5.803z"></path>
            <path d="M14.222 0H1.778C.798 0 0 .798 0 1.778v12.444C0 15.202.798 16 1.778 16h12.444c.98 0 1.778-.798 1.778-1.778V1.778C16 .798 15.202 0 14.222 0ZM4 13.333V2.667L12.889 8 4 13.333Z"></path>
          </svg>
        </div>
      `;

    case "mp3":
    case "wav":
    case "flac":
    case "aac":
    case "ogg":
      return `
        <div style="${wrapperStyle} background-color: #e0f2fe; color: #0284c7; border-color: #bae6fd;">
          <svg fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path d="M14.222 0H1.778C.8 0 0 .8 0 1.778v12.444C0 15.2.8 16 1.778 16h12.444C15.2 16 16 15.2 16 14.222V1.778C16 .8 15.2 0 14.222 0zM3.733 13.333a1.07 1.07 0 0 1-1.066-1.066V8A5.338 5.338 0 0 1 8 2.667 5.338 5.338 0 0 1 13.333 8v4.267a1.07 1.07 0 0 1-1.066 1.066h-2.49V9.778h1.779V8A3.555 3.555 0 0 0 8 4.444 3.555 3.555 0 0 0 4.444 8v1.778h1.778v3.555H3.733z"></path>
          </svg>
        </div>
      `;

    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
      return `
        <div style="${wrapperStyle} background-color: #fffbeb; color: #d97706; border-color: #fde68a;">
          <svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="${svgStyle}">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M10,11H11V12H10V11M11,12H12V13H11V12M10,13H11V14H10V13M11,14H12V15H11V14M10,15H11V16H10V15M11,16H12V17H11V16M12,17H13V18H12V17M13,16V18H15V16H13Z" />
          </svg>
        </div>
      `;

    case "js":
    case "jsx":
      return `
        <div style="${wrapperStyle} background-color: #fef9c3; color: #854d0e; border-color: #fef08a;">
          <span style="font-size: 10px; font-weight: bold; line-height: 1;">JS</span>
        </div>
      `;

    case "ts":
    case "tsx":
      return `
        <div style="${wrapperStyle} background-color: #eff6ff; color: #1d4ed8; border-color: #bfdbfe;">
          <span style="font-size: 10px; font-weight: bold; line-height: 1;">TS</span>
        </div>
      `;

    case "css":
      return `
        <div style="${wrapperStyle} background-color: #f0f9ff; color: #0284c7; border-color: #bae6fd;">
          <span style="font-size: 9px; font-weight: bold; line-height: 1;">CSS</span>
        </div>
      `;

    case "html":
      return `
        <div style="${wrapperStyle} background-color: #fff7ed; color: #c2410c; border-color: #ffedd5;">
          <span style="font-size: 9px; font-weight: bold; line-height: 1;">HTML</span>
        </div>
      `;

    case "json":
      return `
        <div style="${wrapperStyle} background-color: #f1f5f9; color: #475569; border-color: #e2e8f0;">
          <svg fill="currentColor" viewBox="0 0 24 24" style="${svgStyle}">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12V16H9V15H10V14H9V13H10V12H8M11,12V16H12V12H11M13,12V13H14V15H13V16H15V15H14V13H15V12H13Z" />
          </svg>
        </div>
      `;

    case "py":
      return `
        <div style="${wrapperStyle} background-color: #eff6ff; color: #1d4ed8; border-color: #bfdbfe;">
          <span style="font-size: 10px; font-weight: bold; line-height: 1;">PY</span>
        </div>
      `;

    case "java":
      return `
        <div style="${wrapperStyle} background-color: #fef2f2; color: #b91c1c; border-color: #fee2e2;">
          <span style="font-size: 9px; font-weight: bold; line-height: 1;">JV</span>
        </div>
      `;

    case "php":
      return `
        <div style="${wrapperStyle} background-color: #f5f3ff; color: #6d28d9; border-color: #ede9fe;">
          <span style="font-size: 10px; font-weight: bold; line-height: 1;">PHP</span>
        </div>
      `;

    case "md":
      return `
        <div style="${wrapperStyle} background-color: #f8fafc; color: #334155; border-color: #e2e8f0;">
          <svg fill="currentColor" viewBox="0 0 24 24" style="${svgStyle}">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
            <path d="M8,12H10L11,14L12,12H14V18H13V14L11,16L9,14V18H8V12Z" />
          </svg>
        </div>
      `;

    default:
      return `
        <div style="${wrapperStyle} background-color: #f8fafc; color: #64748b; border-color: #e2e8f0;">
          <svg fill="currentColor" viewBox="0 0 24 24" style="${svgStyle}">
            <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
          </svg>
        </div>
      `;
  }
};
